import Modal, { ModalFooter, ModalHeader, Prompt } from "@ingka/modal";
import { type ReactElement, type ReactNode } from "react";
import { createPortal } from "react-dom";

import { Button } from "./Button";

export interface ModalButtonProps {
  text?: string | ReactElement;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

interface Props {
  visible?: boolean;
  onClose: () => void;
  title: string;
  titleId: string;
  closeText?: string;
  children?: ReactNode;
  footer?: ReactNode;
  primaryButtonProps?: ModalButtonProps;
  secondaryButtonProps?: ModalButtonProps;
}
export const ModalPrompt = ({
  visible,
  onClose,
  title,
  titleId,
  children,
  closeText,
  footer,
  primaryButtonProps,
  secondaryButtonProps,
}: Props) => {
  const root = document.querySelector("#modal-prompt");
  if (!root) {
    return null;
  }
  return createPortal(
    <Modal prefix="saleslead__" visible={visible} handleCloseBtn={onClose}>
      <Prompt
        prefix="saleslead__"
        titleId={titleId}
        title={title}
        closeBtnClick={onClose}
        header={<ModalHeader prefix="saleslead__" closeBtnClick={onClose} />}
        footer={
          <ModalFooter prefix="saleslead__">
            {footer ?? (
              <>
                {secondaryButtonProps && (
                  <Button
                    type="secondary"
                    text={secondaryButtonProps?.text ?? closeText ?? "cancel"}
                    onClick={secondaryButtonProps?.onClick}
                    loading={secondaryButtonProps?.loading}
                  />
                )}
                {primaryButtonProps && (
                  <Button
                    type="primary"
                    text={primaryButtonProps?.text}
                    onClick={primaryButtonProps?.onClick}
                    loading={primaryButtonProps?.loading}
                  />
                )}
              </>
            )}
          </ModalFooter>
        }
      >
        {children}
      </Prompt>
    </Modal>,
    root
  );
};
